import React, { useEffect, useState, useRef } from "react";

import hotboi from "../imagesJotP/hotboi.jpg";

import reporting1 from "../imagesJotP/GvIIuA9W0AAtu4e.jpg";
import reporting2 from "../imagesJotP/GvIIuBDXMAAOC7w.jpg";

import * as tf from "@tensorflow/tfjs";
import * as faceLandmarksDetection from "@tensorflow-models/face-landmarks-detection";

import { TwitterTweetEmbed } from "react-twitter-embed";

const TestamentArk = () => {
  //////////

  // Load the image using tf

  const [detector, setDetector] = useState(null);

  const [imageUrl1, setImageUrl1] = useState(reporting1); // Replace with your tweet image URL
  const [imageUrl2, setImageUrl2] = useState(reporting2); // Replace with your tweet image URL

  useEffect(() => {
    const loadDetector = async () => {
      const detector = await faceLandmarksDetection.createDetector(
        faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh,
        {
          runtime: "tfjs",
        }
      );
      setDetector(detector);
    };
    loadDetector();
  }, []);

  //   useEffect(() => {
  //     const detectFaces = async () => {
  //       if (detector) {
  //         const img = document.getElementById("image");
  //         const faces = await detector.estimateFaces(img);
  //         const canvas = document.getElementById("canvas");
  //         const ctx = canvas.getContext("2d");
  //         ctx.drawImage(img, 0, 0);
  //         faces.forEach((face) => {
  //           const keypoints = face.keypoints;
  //           ctx.beginPath();
  //           ctx.moveTo(keypoints[0].x, keypoints[0].y);
  //           for (let i = 1; i < keypoints.length; i++) {
  //             ctx.lineTo(keypoints[i].x, keypoints[i].y);
  //           }
  //           ctx.strokeStyle = "blue";
  //           ctx.stroke();
  //         });
  //       }
  //     };
  //     detectFaces();
  //   }, [detector]);

  const maxWidth = 400;
  const maxHeight = 600;

  useEffect(() => {
    const detectFaces = async () => {
      if (detector) {
        const img = document.getElementById("image1");
        img.src = imageUrl1;

        img.onload = async () => {
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;
            if (aspectRatio > maxWidth / maxHeight) {
              width = maxWidth;
              height = maxWidth / aspectRatio;
            } else {
              width = maxHeight * aspectRatio;
              height = maxHeight;
            }
          }

          const faces = await detector.estimateFaces(img);
          const canvas = document.getElementById("canvas1");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          faces.forEach((face) => {
            const keypoints = face.keypoints;
            ctx.beginPath();
            ctx.moveTo(
              keypoints[0].x * (width / img.width),
              keypoints[0].y * (height / img.height)
            );
            for (let i = 1; i < keypoints.length; i++) {
              ctx.lineTo(
                keypoints[i].x * (width / img.width),
                keypoints[i].y * (height / img.height)
              );
            }
            ctx.strokeStyle = "blue";
            ctx.stroke();
          });
        };
      }
    };
    detectFaces();
  }, [detector, imageUrl1]);

  useEffect(() => {
    const detectFaces = async () => {
      if (detector) {
        const img = document.getElementById("image2");
        img.src = imageUrl2;
        img.onload = async () => {
          let width = img.width;
          let height = img.height;

          if (width > maxWidth || height > maxHeight) {
            const aspectRatio = width / height;
            if (aspectRatio > maxWidth / maxHeight) {
              width = maxWidth;
              height = maxWidth / aspectRatio;
            } else {
              width = maxHeight * aspectRatio;
              height = maxHeight;
            }
          }

          const faces = await detector.estimateFaces(img);
          const canvas = document.getElementById("canvas2");
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(img, 0, 0, width, height);
          faces.forEach((face) => {
            const keypoints = face.keypoints;
            ctx.beginPath();
            ctx.moveTo(
              keypoints[0].x * (width / img.width),
              keypoints[0].y * (height / img.height)
            );
            for (let i = 1; i < keypoints.length; i++) {
              ctx.lineTo(
                keypoints[i].x * (width / img.width),
                keypoints[i].y * (height / img.height)
              );
            }
            ctx.strokeStyle = "blue";
            ctx.stroke();
          });
        };
      }
    };
    detectFaces();
    detectFaces();
  }, [detector, imageUrl2]);

  ///////
  //   const tweetId = "1941623997784809969"; // Replace with your tweet ID
  //   const tweetId2 = "1939365157697888605";

  //   const tweetUrl = "https://twitter.com/ffavoidance/status/1941623997784809969"; // Replace with your tweet URL

  //   useEffect(() => {
  //     const fetchTweetData = async () => {
  //       const response = await fetch(
  //         `https://publish.twitter.com/oembed?url=${tweetUrl}`
  //       );
  //       const data = await response.json();
  //       console.log(data);
  //     };
  //     fetchTweetData();
  //   }, []);

  //////

  //////
  // writer name

  //   const tweetUrl = 'https://twitter.com/username/status/tweet-id';
  // const params = {
  //   url: tweetUrl,
  //   format: 'json',
  // };

  // axios.get('https://publish.twitter.com/oembed', { params })
  //   .then(response => {
  //     const embedCode = response.data.html;
  //     // Use the embed code in your application
  //     console.log(embedCode);
  //   })
  //   .catch(error => {
  //     console.error(error);
  //   });

  //

  //   const [coresObj, setCoresObj] = useState();
  //   const [coresObj, setCoresObj] = useState();
  //   const [coresObj, setCoresObj] = useState();

  return (
    <div className="testamentArk1John15">
      <div className="testamentArk1John15-courtyard-setting"></div>
      <div className="testamentArk1John15-TempleGridGemStone">
        powered by{" "}
        <h3 style={{ paddingLeft: "2rem", margin: ".2rem" }}>TempleGrid</h3>{" "}
      </div>
      <div className="testamentArk1John15-templeCatwalk">
        <div className="testamentArk1John15-templeCatwalk">
          <div>
            <img src={hotboi} alt="babe" />
          </div>
          <div className="testamentArk1John15-libraryScribe">CEO Zeus</div>
        </div>
        {/* background pink and blue  */}

        <div className="testamentArk1John15-porch">
          <div className="testamentArk1John15-blobBlades">
            reportings
            <hr
              style={{
                border: "none",
                height: "1px",
                background:
                  " linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1), rgba(255, 255, 255, 0))",
              }}
            />
          </div>
          <div className="testamentArk1John15-blobBlades">
            {`%`}1200 Rapings
          </div>
          <div className="testamentArk1John15-blobBlades">Secured</div>
          <div>
            {/* <div>
              <img
                id="image"
                src={hotboi}
                alt="Image"
                style={{ display: "none" }}
              />
              <canvas id="canvas" width={400} height={400} />
            </div> */}
            <div style={{ display: "inline-block" }}>
              <img
                id="image1"
                src={reporting1}
                alt="Image"
                style={{ display: "none" }}
              />
              <canvas id="canvas1" width={400} height={400} />
            </div>
            <div style={{ display: "inline-block", padding: "1rem" }}>
              <img
                id="image2"
                src={reporting2}
                alt="Image"
                style={{ display: "none" }}
              />
              <canvas id="canvas2" width={400} height={400} />
            </div>
            {/* <TwitterTweetEmbed tweetId={tweetId} />
            <TwitterTweetEmbed tweetId={tweetId2} /> */}
            <blockquote class="twitter-tweet">
              <p lang="en" dir="ltr">
                I was about to start my defense company … and then they lit 15
                Jews on fire . To attack Jews ( my defense company ) . Wow
                🦁☀️💙🌠🛡️🇮🇱{" "}
                <a href="https://twitter.com/hashtag/JotP?src=hash&amp;ref_src=twsrc%5Etfw">
                  #JotP
                </a>{" "}
                <a href="https://twitter.com/hashtag/TempleGrid?src=hash&amp;ref_src=twsrc%5Etfw">
                  #TempleGrid
                </a>{" "}
                🏦🇮🇱🇻🇦🇺🇸{" "}
                <a href="https://t.co/KQcLRB776h">pic.twitter.com/KQcLRB776h</a>
              </p>
              &mdash; Zeus 🇬🇷👑💎👑🇬🇷 (@ffavoidance){" "}
              <a href="https://twitter.com/ffavoidance/status/1941623997784809969?ref_src=twsrc%5Etfw">
                July 5, 2025
              </a>
            </blockquote>{" "}
            <blockquote class="twitter-tweet">
              <p lang="en" dir="ltr">
                I’m a catholic I’m a catholic 🦁🇻🇦☀️💙🌠
              </p>
              &mdash; Zeus 🇬🇷👑💎👑🇬🇷 (@ffavoidance){" "}
              <a href="https://twitter.com/ffavoidance/status/1939365157697888605?ref_src=twsrc%5Etfw">
                June 29, 2025
              </a>
            </blockquote>{" "}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestamentArk;
